import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function SEO({ description, lang, meta, title }) {
	var client_name = process.env.REACT_APP_CLIENT_NAME;
	var my_title = 'Trabaja en ' + client_name;
	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={my_title}
			meta={[
				{
					name: `description`,
					content: `Aplica a las vacantes de empleo de ${client_name}`,
				},
				{
					property: `og:title`,
					content: my_title,
				},
				{
					property: `og:description`,
					content: `Aplica a las vacantes de empleo de ${client_name}`,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					name: `twitter:card`,
					content: `Aplica a las vacantes de empleo de ${client_name}`,
				},
				{
					name: `twitter:title`,
					content: my_title,
				},
				{
					name: `twitter:description`,
					content: `Aplica a las vacantes de empleo de ${client_name}`,
				},
				{
					name: `og:image`,
					content: `https://tcn-assets.hiperjob.com/${client_name}/images/header_landing.png`,
				},
			].concat(meta)}
		/>
	);
}

SEO.defaultProps = {
	lang: `en`,
	meta: [],
	description: ``,
};

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired,
};

export default SEO;
